module.exports = require('./generateVideoEmbedUrl')
